export class Constants {
    public static defaultActivePage: number = 1;
    public static recordsPerPage: number = 20;
    public static expireOtpTimeInSecond: number = 60;
    public static expireOtpTimeInSecondForEmail: number = 180;
    public static uploadFileSizeLimit: number = 5242880; //5 MB
    public static OtherId: string = '1';
    public static OtherIdInt: number = 1;
    public static debounceTime = 10;
    public static publicKey: string = '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAskgPKBcNpz71mi4NSYa5mazJrO0WZim7T2yy7qPxk2NqQE7OmWWakLJcaeUYnI0kO3yC57vck66RPCjKxWuWSGZ7dHXe0bWb5IXjcT4mNdnUIalR+lV8czsoH/wDUvkQdG1SJ+IxzW64WvoaCRZ+/4wBF2cSUh9oLwGEXiodUJ9oJXFZVPKGCEjPcBI0vC2ADBRmVQ1sKsZg8zbHN+guU9rPLFzN4YNrCnEsSezVw/W1FKVS8J/Xx4HSSg7AyVwniz8eHi0e3a8VzFg+H09I5wK+w39sjDYfAdnJUkr6PjtSbN4/Sg/NMkKB2Ngn8oj7LCfe/7RNqIdiS+dQuSFgeQIDAQAB-----END PUBLIC KEY-----';

    /* ---- Messages  ---- */
    public static msgSendOtp: string = 'OTP sent successfully.';
    public static msgResendOtp: string = 'OTP resent successfully.';
    public static msgVerifiedUser: string = 'Mobile number verification successful.';
    public static msgPasswordCreated: string = 'Password created successfully.';
    public static msgUserAlreadyRegister: string = 'You are already registered and verified. Sign in to proceed.';
    public static msgSomethingWrong: string = 'Something went wrong. Please try again.';
    public static msgOtpExpired: string = 'OTP has expired. Please click on resend OTP';
    public static msgAllowedFiles: string = 'Invalid file format. Allowed file formats are jpg, jpeg, png, pdf';
    public static msgAllowedFilesLimit: string = 'Please upload a file with a size limit of less than 5 MB.';
    public static msgEmptyFileNotAllowed: string = 'Unable to upload empty file.Please select another file.';
    public static defaultDate: string = '1900-01-01T00:00:00';
    public static msgFileContentNotfound: string = 'File content not found.';
    public static msgDataNotfound: string = 'Data not found';
}